import {useCallback} from 'react';
import {useRequestLogin} from '~/common/fabric/Card/components/LoginModal/hooks/useRequestLogin';
import {Button} from '~library/atoms/Button';
import {useTracking} from '~library/context/tracking/tracking-context';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {FavoritesLineIcon} from '~library/svg/FavoritesLineIcon';
import * as styles from './Favorites.module.scss';

export const Favorites = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const {loggedIn, requestLogin} = useRequestLogin();
  const {track} = useTracking();

  const FavIcon = () => <FavoritesLineIcon ratio={0.625} />;

  const goToFavorites = useCallback(() => {
    track({
      dataQaId: 'nav-bar-favorites',
      href: '/gallery/favorites',
    });
    window.location.href = '/gallery/favorites';
  }, [track]);

  const onRequestLoginHandler = useCallback(async () => {
    track({
      dataQaId: 'nav-bar-favorites-login',
      href: '/gallery/favorites',
    });
    if (await requestLogin()) {
      goToFavorites();
    }
  }, [requestLogin, goToFavorites, track]);

  if (!isLargishAndUp && !loggedIn) {
    return null;
  }

  return (
    <Button
      onClick={loggedIn ? goToFavorites : onRequestLoginHandler}
      variant="unstyled-button"
      data-qa-id="nav-bar-favorites"
      disableProcessing
      className={styles.favIcon}
    >
      <FavIcon />
    </Button>
  );
};
